import axios from 'axios'
import tokenService from './token'
import { createApiUrl } from '../config/api'

const quizUrl = createApiUrl('/api/accounts/quiz/')
const recommendedUrl = createApiUrl('/api/search/recommended/')

const buildRecommendedUrl = (quizResults) => {
    if (!quizResults) return recommendedUrl

    const params = new URLSearchParams()
    Object.entries(quizResults).forEach(([key, value]) => {
        const values = Array.isArray(value) ? value : [value]
        values
            .filter(item => item !== null && item !== undefined && item !== '')
            .forEach(item => params.append(key, item))
    })

    const query = params.toString()
    return query ? `${recommendedUrl}?${query}` : recommendedUrl
}

const getQuizResults = async () => {
    const res = await axios.get(quizUrl, tokenService.getAuthHeader())
    return res.data
}

const saveQuizResults = async (data) => {
    const res = await axios.post(quizUrl, data, tokenService.getAuthHeader())
    return res.data
}

const getRecommended = async (quizResults = null) => {
    const res = await axios.get(buildRecommendedUrl(quizResults), tokenService.getAuthHeader())
    return res.data
}

const quizService = { getQuizResults, saveQuizResults, getRecommended }

export default quizService
